import React, { memo, useRef, useContext } from 'react';
import { DropdownMenu, DropdownItem, Button } from '@cashfree-intl/coherent';

import { StyledCheckbox, DropdownCTAGroup, StyledDropdown } from './styled';
import { Option } from '../types';
import { DropdownContext } from './DropdownContext';
import { getSelectedCount } from '../helpers';

interface IMultiSelectDropdownProps {
  name: string;
  placeholder: string;
  value: Option[];
  options: Option[];
  disabled: boolean;
  setFieldError: (name: string, value: any) => void;
  setFieldTouched: (name: string) => void;
  setFieldValue: (
    name: string,
    value: object[] | ((prev: object[]) => object[]),
  ) => void;
}

function MultiSelectDropdown({
  options,
  name,
  setFieldTouched,
  setFieldValue,
  setFieldError,
  placeholder,
  disabled,
  value = [],
}: IMultiSelectDropdownProps) {
  // @ts-ignore
  const { openDropdown, setOpenDropdown } = useContext(DropdownContext);

  const dropdownRef = useRef(null);

  const onOptionClick = option => (e) => {
    // check if already present in selected
    const { value: selectedValue } = option;

    const index = value.findIndex(obj => obj.value === selectedValue);

    let data = JSON.parse(JSON.stringify(value));
    
    // handle the scenario for ALL option
    if (index > -1) {
      if (selectedValue === 'ALL') {
        data = [];
      } else {
        data.splice(index, 1);
        // remove the ALL if all is present
        if (data[0]?.value === 'ALL') {
          data.splice(0, 1);
        }
      }
      setFieldValue(name, data);
    } else {
      if (selectedValue === 'ALL') {
        data = options;
      } else {
        data.push(option);
      }
      setFieldValue(name, data);
    }
    if (data.length > 0) setFieldError(name, '');
  };

  const onSave = () => {};

  const onReset = () => {
    // clear every selection and set the values to initial state
    // setSelected([]);
    setFieldValue(name, []);
  };

  const selectedCount = getSelectedCount(value);

  return (
    <StyledDropdown
      disabled={disabled || options.length === 0}
      selection
      ref={dropdownRef}
      placeholder={placeholder}
      icon="chevron down"
      text={selectedCount > 0 ? `${selectedCount} selected` : null}
      key={name}
      className={`${name}${selectedCount > 0 ? ' elements-selected' : ''}`}
      open={openDropdown === null ? false : openDropdown === dropdownRef?.current?.ref?.current}
      onClick={() => {
        // @ts-ignore
        setOpenDropdown(dropdownRef.current?.ref?.current);
      }}
      onBlur={() => setFieldTouched(name)}
    >
      {/* {openDropdown === dropdownRef?.current?.ref?.current ? ( */}
        <DropdownMenu>
          {options.map((option, index) => (
            <DropdownItem key={option.key} onClick={onOptionClick(option)}>
              <StyledCheckbox
                label={option.text}
                className={index > 0 ? 'ml-2' : ''}
                checked={!!value.find(obj => obj.value === option.value)}
                data-event-name="Dropdown_Item"
                data-ignore-inner-text="true"
                data-event-properties={JSON.stringify({
                  dropdown_id: option.key,
                })}
                onClick={(e)=>{e.stopPropagation(); onOptionClick(option)(e)}}
              />
            </DropdownItem>
          ))}
          <DropdownCTAGroup
            alignItems="center"
            justifyContent="space-between"
            className="p-2 pb-3"
          >
            <Button
              className="multiselect-dropdown-save-button"
              primary
              type="button"
              onClick={onSave}
              size="small"
              data-event-name="Primary_Button_Save"
              data-ignore-inner-text="true"
            >
              Save
            </Button>
            <Button
              secondary
              type="button"
              onClick={onReset}
              size="small"
              data-event-name="Form_UpfrontTDR_Button_Reset"
              data-ignore-inner-text="true"
            >
              Reset
            </Button>
          </DropdownCTAGroup>
        </DropdownMenu>
      {/* ):<></>} */}
    </StyledDropdown>
  );
}

export default memo(MultiSelectDropdown);
